import axiosInstance from '@/service/helpers/axios'
export async function getNotification() {
  const result = await axiosInstance.get('/notification/list')
  return result
}
export async function setAsRead(id: number) {
  const result = await axiosInstance.get('/notification/set-to-read/' + id)
  return result
}
